import { Navigate, Outlet} from 'react-router-dom';

const ProtectedRoute = ({ authToken, children }) => {
    if (!authToken) {
        return <Navigate to="/" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;